export const namespace = 'applications';

export const MutationTypes = {
  SET_APPLICATIONS: 'SET_APPLICATIONS',
  SET_APPLICATION_USERS: 'SET_APPLICATION_USERS',
  SET_APPLICATION_HISTORY: 'SET_APPLICATION_HISTORY',
};

export const ActionTypes = {
  GET_APPLICATIONS: 'GET_APPLICATIONS',
  GET_APPLICATION_USERS: 'GET_APPLICATION_USERS',
  GET_APPLICATION_HISTORY: 'GET_APPLICATION_HISTORY',
};
